import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import styled from 'styled-components';

const ProductsLaunching = () => {
    return (
        <Wrapper>
            <div className='container' style={{ marginBottom: '20px', backgroundColor:'#f8fafc', padding:'10px', borderRadius:'10px'}}>
                <h4 className='ms-0 ms-sm-2'>Product Launching</h4>
                <div>
                    <Carousel interval={3000} pause={false} controls={false}>
                        <Carousel.Item>
                            <img src='./images/ProductsLaunching.jpg' className='image-fluid' style={{width:'100%'}}/>
                        </Carousel.Item>
                        <Carousel.Item>
                            <img src='./images/ProductsLaunching.jpg' className='image-fluid' style={{width:'100%'}}/>
                        </Carousel.Item>
                    </Carousel>
                </div>
            </div>
        </Wrapper>
    )
}

export default ProductsLaunching

const Wrapper = styled.section`
    .carousel-indicators {
        display:none !important;
    }
`